<template>
  <Modal class-name="vertical-center-modal" v-model="isPriveteKey" title="设置应用私钥" width="460">
    <div class="form-wrapper">
      <Form :model="keyForm"
            label-position="right"
            :label-width="100">
        <FormItem label="请输入新参数">
          <div class="form-group">
            <textarea v-model="keyForm.application_key" placeholder="请输入应用私钥"></textarea>
          </div>
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="handelSubmit">保存</span>
      </div>
    </div>
    <Spin size="large" fix v-show="loading"></Spin>
  </Modal>
</template>

<script>
  import { Modal, Form, FormItem, Spin } from 'view-design'
  import set from '@/javaApi/set'
  const setModel = new set()
  export default {
    name: "PriveteKey",
    components: {
      Modal,
      Form,
      FormItem,
      Spin
    },
    data: function() {
      return {
        isPriveteKey: false,
        loading: false,
        keyForm: {
          application_key: ''
        },
        sourceData:{

        }
      }
    },
    methods: {
      init: function(isPriveteKey,data) {
        this.loading = true
        this.isPriveteKey = isPriveteKey
        this.loading = false
        this.sourceData = data
      },
      handelSubmit: function(){
        if(this.loading){
          return
        }
        this.loading = true
        if(!this.keyForm.application_key){
          this.$Message.error('请设置应用私钥')
          return
        }
        let that = this
        this.sourceData.privateKey = this.keyForm.application_key
        setModel.saveWithdrawSet(this.sourceData).then(response=>{
          let res = response.data
          this.loading = false
          if(res.code == 200){
            this.$message.success('保存成功')
            this.$emit('PrivateKey',this.keyForm.application_key)
          }else{
            let message = res.message?res.message:'系统繁忙请稍后再试！'
            this.$message.error(message)
          }
          setTimeout(function () {
            that.isPriveteKey = false;
          },500)
        }).catch(error=>{
          this.loading = false
            if(error != 'token invalid'){
                this.$message.error('系统繁忙请稍后再试!')
            }
        })
      }
    }
  }
</script>


<style scoped>
  .normal-font {
    color: #ff8622;
    font-size: 14px;
  }
  >>>.vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  >>>.vertical-center-modal .ivu-modal {
    top: 0;
    width: 300px;
  }
  >>>.vertical-center-modal .ivu-modal-footer {
    border-top: none;
    padding: 12px 18px 12px 18px;
    text-align: right;
  }
  .footer-wrapper {
    display: flex;
    min-width: 0;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  .footer-wrapper .btn {
    display: inline-block;
    border-radius: 4px;
    margin-right: 10px;
    padding: 0px 15px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    vertical-align: middle;
    cursor: pointer;
  }
  .footer-wrapper .btn.confirm-btn {
    background: #ff8622;
    color: #fff;
  }
  .footer-wrapper .btn.cancel-btn {
    border: 1px solid #eeeeee;
    border-radius: 2px;
    color: #222222;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/official/set/modal/PrivateKey.vue